import { useGraphqlQuery } from "@bsm/component"
import { TUserStudent } from "@bsm/graphql"
import { StudentDetailsQuery } from "../queries/StudentDetailsQuery"

export const useStudentDetailsQuery = (id?: number, suspense?: boolean) => {
    return useGraphqlQuery<StudentDetailsQuery, TUserStudent>(new StudentDetailsQuery({id}), {enabled: id !== undefined, suspense})
}